module.exports = __webpack_public_path__ + "img/security-audit-img-6.6d4898f9.png";